'use client'

import { glovoMedia } from '@glovo/multimedia'
import { getProviders } from './providers/providers'
import type { GetImageParams } from './types'
import { glovoRum } from '@/tools/o11y/client'

let isInitialized = false

export const getImageUrl = ({ source, options }: GetImageParams): string => {
  if (!isInitialized) {
    glovoMedia.init({ providers: getProviders(), onError: glovoRum?.addError })
    isInitialized = true
  }

  return glovoMedia.getImageUrl(source, options)
}
